import { combineReducers } from "redux";
import beneficiaries from "./beneficiaries";
import donations from "./donations";
import email from "./email";
import events from "./events";
import login from "./login";
import notifications from "./notifications";
import donationNotification from "./donationNotification";
import pinnacleMessage from "./pinnacleMessage";
import processingFee from "./processingfee";
import processingFeeVendor from "./processingFeeVendor";
import teams from "./teams";

export default combineReducers({
  beneficiaries,
  donations,
  email,
  events,
  login,
  processingFee,
  processingFeeVendor,
  notifications,
  pinnacleMessage,
  donationNotification,
  teams,
});
